var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.432v11.137a2.792 2.792 0 002.786 2.786h9.002a2.792 2.792 0 002.786-2.786v-1.804a.552.552 0 10-1.104 0v1.804a1.69 1.69 0 01-1.687 1.687H2.786A1.69 1.69 0 011.1 16.569V5.432a1.69 1.69 0 011.687-1.687h9.002a1.69 1.69 0 011.687 1.687v1.804a.552.552 0 101.103 0V5.432a2.792 2.792 0 00-2.786-2.786H2.786A2.79 2.79 0 000 5.432z",
    fill: "#F48026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.293 15.15a.547.547 0 00.39.162.547.547 0 00.39-.161l3.765-3.765a.547.547 0 000-.776l-3.764-3.765a.547.547 0 00-.776 0 .547.547 0 000 .776l2.827 2.827H9.809a.552.552 0 100 1.104H20.12l-2.827 2.827a.542.542 0 000 .772z",
    fill: "#F48026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.31b6ef5d2348e8aff12bedd46bd42e2d.svg";
export { ForwardRef as ReactComponent };